// extracted by mini-css-extract-plugin
module.exports = {"team_nav_box":"game_id_nav-module--team_nav_box--WhbB9","team_id_link":"game_id_nav-module--team_id_link--1n3TN"};